// ─────────────────────────────────────────────────
// Daily Touchpoints — Time-based behavior loop
// ─────────────────────────────────────────────────

export type TouchpointId =
  | 'morning_nudge'
  | 'focus_session'
  | 'midday_pulse'
  | 'afternoon_focus'
  | 'evening_reflection'
  | 'growth_moment'
  | 'weekly_synthesis';

export interface TouchpointConfig {
  id: TouchpointId;
  emoji: string;
  nameKo: string;
  timeRange: { start: number; end: number }; // 24h format
  route: string;
  durationMinutes: number; // expected completion time
  description: string;
}

export const TOUCHPOINT_CONFIGS: TouchpointConfig[] = [
  {
    id: 'morning_nudge',
    emoji: '🌅',
    nameKo: '아침 계획',
    timeRange: { start: 6, end: 10 },
    route: '/checkin',
    durationMinutes: 2,
    description: '오늘 뭘 해볼까? 아침 계획 세우기',
  },
  {
    id: 'focus_session',
    emoji: '⏱️',
    nameKo: '집중 시간',
    timeRange: { start: 9, end: 12 },
    route: '/timer',
    durationMinutes: 25,
    description: '집중 세션 시작하기',
  },
  {
    id: 'midday_pulse',
    emoji: '⚡',
    nameKo: '점심 에너지 체크',
    timeRange: { start: 12, end: 14 },
    route: '/pulse',
    durationMinutes: 1,
    description: '30초 에너지 재체크',
  },
  {
    id: 'afternoon_focus',
    emoji: '🎯',
    nameKo: '오후 집중',
    timeRange: { start: 13, end: 18 },
    route: '/timer',
    durationMinutes: 25,
    description: '조정된 전략으로 오후 집중',
  },
  {
    id: 'evening_reflection',
    emoji: '🌙',
    nameKo: '저녁 돌아보기',
    timeRange: { start: 18, end: 22 },
    route: '/checkin',
    durationMinutes: 3,
    description: '오늘 하루를 돌아보고 정리하기',
  },
  {
    id: 'growth_moment',
    emoji: '💡',
    nameKo: '성장 한 걸음',
    timeRange: { start: 20, end: 23 },
    route: '/growth-moment',
    durationMinutes: 2,
    description: '오늘의 성찰 질문 하나',
  },
  {
    id: 'weekly_synthesis',
    emoji: '📊',
    nameKo: '주간 리포트',
    timeRange: { start: 0, end: 24 }, // all day on Sunday
    route: '/profile/weekly-report',
    durationMinutes: 5,
    description: '한 주 돌아보기 + 다음 주 계획',
  },
];

/** Midday pulse record */
export interface MiddayPulse {
  id: string;
  date: string;
  energyLevel: number;
  progressNote: string;
  createdAt: string;
}

/** Growth moment reflection */
export interface GrowthMoment {
  id: string;
  date: string;
  questionId: string;
  question: string;
  response: string;
  aiComment?: string;
  frameworkId?: string;
  createdAt: string;
}
